function initCertificate() {
  const form = {
    design: '',
    nominal: '',
    quantity: '1',
    message: '',
    email: '',
    friend: '',
    me: true,
    now: true,
    date: '',
    time: '',
    notify: true,
    agree: true
  };

  function validationForm() {
    let isValid = true;

    if (!form.agree || form.design === '' || form.quantity === '' || form.email === '' || (form.me === 'false' && form.now === 'false' && (form.date === '' || form.time === '')) || (form.me === 'false' && form.friend === '')) {
      isValid = false;
    }

    if (previewBtn) previewBtn.disabled = !isValid;
    if (buyBtn) buyBtn.disabled = !isValid;
  }

  const previewBtn = document.querySelector('[data-preview-btn]');
  const buyBtn = document.querySelector('[data-buy-btn]');

  if (previewBtn) {
    const certificateInputs = document.querySelectorAll('.certificate input');
    const certificateTimeInputs = document.querySelector('.certificate__time-inputs');
    const certificateTime = document.querySelector('.certificate__time');

    certificateInputs.forEach((certificateInput) => {
      certificateInput.addEventListener('input', () => {
        const certificateInputName = certificateInput.getAttribute('name');
        const certificateInputValue = certificateInput.value;
        form[certificateInputName] = certificateInputValue;

        if (certificateInputName === 'now') {
          if (certificateInputValue === 'true') {
            certificateTimeInputs.style.display = 'none';
          } else {
            certificateTimeInputs.style.display = 'flex';
          }
        }

        if (certificateInputName === 'me') {
          if (certificateInputValue === 'true') {
            certificateTime.style.display = 'none';
          } else {
            certificateTime.style.display = 'block';
          }
        }

        if (certificateInput.type === 'checkbox') {
          form[certificateInputName] = certificateInput.checked;
        }

        validationForm();
      });
    });

    const certificateOtherInputs = document.querySelectorAll('.certificate__input');

    certificateOtherInputs.forEach((certificateInput) => {
      certificateInput.addEventListener('input', () => {
        const certificateInputName = certificateInput.getAttribute('name');
        const certificateInputValue = certificateInput.value;
        form[certificateInputName] = certificateInputValue;

        validationForm();
      });
    });

    setTimeout(() => {
      const certificateNominal = document.querySelector('select[name="nominal"]');

      if (certificateNominal) {
        form.nominal = certificateNominal.value;

        certificateNominal.addEventListener('change', () => {
          form.nominal = certificateNominal.value;
        });
      }
    }, 1000);

    if (previewBtn) previewBtn.addEventListener('click', () => {
      const previewImg = document.querySelector('.preview__img');
      const previewImgSrc = previewImg.getAttribute('src');

      if (previewImgSrc !== form.design) {
        previewImg.setAttribute('src', form.design);
      }

      const previewMessage = document.querySelector('.preview__message');
      const previewMessageText = previewMessage.textContent;
      const previewBlockBig = document.querySelector('.preview__block--big');
      const previewBlockSmall = document.querySelector('.preview__block--small');
      const previewBlockMessage = document.querySelector('.preview__block--message');

      if (previewMessageText !== form.message) {
        previewMessage.textContent = form.message;
      }

      if (previewMessage.textContent) {
        previewBlockMessage.style.display = 'flex';
        previewBlockBig.style.display = 'none';
        previewBlockSmall.style.display = 'flex';
      } else {
        previewBlockMessage.style.display = 'none';
        previewBlockBig.style.display = 'flex';
        previewBlockSmall.style.display = 'none';
      }

      const previewBlockNominals = document.querySelectorAll('.preview__block-nominal span');

      previewBlockNominals.forEach((previewBlockNominal) => {
        const previewBlockNominalText = previewBlockNominal.textContent;

        if (previewBlockNominalText !== form.nominal) {
          previewBlockNominal.textContent = form.nominal;
        }
      });
    })

    const certificateDesignVariants = document.querySelectorAll('.certificate__design-variant');
    const certificateCurrentDesignImg = document.querySelector('.certificate__current-design-img');
    const certificateCurrentDesignImgSrc = certificateCurrentDesignImg.getAttribute('src');
    form.design = certificateCurrentDesignImgSrc;

    certificateDesignVariants.forEach((certificateDesignVariant) => {
      certificateDesignVariant.addEventListener('click', (evt) => {
        const certificateDesignVariantImg = certificateDesignVariant.querySelector('.certificate__design-variant-img');
        const certificateDesignVariantImgSrc = certificateDesignVariantImg.getAttribute('src');

        certificateCurrentDesignImg.setAttribute('src', certificateDesignVariantImgSrc);
        form.design = certificateDesignVariantImgSrc;

        validationForm();
      });
    });

    const certificateQuantityBtnMinus = document.querySelector('.certificate__quantity-btn--minus');
    const certificateQuantityBtnPlus = document.querySelector('.certificate__quantity-btn--plus');
    const certificateQuantityValue = document.querySelector('.certificate__quantity-value');

    certificateQuantityBtnMinus.addEventListener('click', () => {
      const certificateQuantityValueNumber = Number(certificateQuantityValue.textContent);

      if (certificateQuantityValueNumber > 1) {
        certificateQuantityValue.textContent = certificateQuantityValueNumber - 1;
        form.quantity = certificateQuantityValueNumber - 1;

        validationForm();
      }
    });

    certificateQuantityBtnPlus.addEventListener('click', () => {
      const certificateQuantityValueNumber = Number(certificateQuantityValue.textContent);

      certificateQuantityValue.textContent = certificateQuantityValueNumber + 1;
      form.quantity = certificateQuantityValueNumber + 1;

      validationForm();
    });

    const certificateMessageTitleCounter = document.querySelector('.certificate__message-title span');
    const certificateInputTextarea = document.querySelector('.certificate__input--textarea');

    certificateInputTextarea.addEventListener('input', () => {
      const certificateInputTextareaValueLength = certificateInputTextarea.value.length;
      certificateMessageTitleCounter.textContent = certificateInputTextareaValueLength;
    });
  }

  if (window.location.href.includes('success')) {
    window.modals.open('preview');

    function generatePDF() {
      var element = document.getElementById("content");

      if (element) {
        // Убираем возможное влияние DPR на изображение
        const scale = window.devicePixelRatio || 1;

        html2canvas(element, {
          scale: scale, // Устанавливаем scale, чтобы результат был одинаковым на всех устройствах
          scrollX: 0, // Убираем прокрутку по горизонтали
          scrollY: -window.scrollY, // Убираем прокрутку по вертикали
          useCORS: true, // Если изображение с другого домена, чтобы избежать проблем с CORS
          allowTaint: true, // Для того чтобы изображения и другие элементы не блокировались
          logging: true, // Логирование ошибок для отладки
          width: element.scrollWidth, // Указываем фактическую ширину элемента
          height: element.scrollHeight, // Указываем фактическую высоту элемента
          x: 0,
          y: 0
        }).then(function (canvas) {
          const { jsPDF } = window.jspdf;

          // Уменьшаем размеры изображения в 2 раза
          const reducedWidth = canvas.width / 2;
          const reducedHeight = canvas.height / 2;

          // Создаем новый PDF с размерами, равными уменьшенным размерам изображения
          const doc = new jsPDF('p', 'mm', [reducedWidth, reducedHeight]);

          const imgData = canvas.toDataURL('image/png');

          // Добавляем изображение в PDF с уменьшенными размерами
          doc.addImage(imgData, 'PNG', 0, 0, reducedWidth, reducedHeight);

          // Сохраняем PDF
          doc.save('certificate.pdf');
        }).catch(function (error) {
          console.error("Ошибка при создании изображения: ", error);
        });
      } else {
        console.error("Элемент с id 'content' не найден.");
      }
    }

    generatePDF();
  }
}

export { initCertificate };
